'use client';

import Link from 'next/link';

const toDomains = (cookie) => {
  if (cookie.groupHandle === 'HOST') {
    return Object.keys(cookie.domains).reduce((acc, host) => {
      const i = acc.findIndex((e) => e === host);
      if (i === -1) return [...acc, host];
      return acc;
    }, []);
  } else if (cookie.groupHandle === 'DOMAIN') {
    return Object.keys(cookie.domains).reduce((acc, host) => {
      const value = cookie.domains[host];
      const i = acc.findIndex((e) => e === value);
      if (i === -1) return [...acc, value];
      return acc;
    }, []);
  }
};

interface Props {
  cookie: any;
  organization: string;
}

const CookieService = ({ cookie, organization }: Props) => (
  <div className="flex flex-col text-center p-0 md:py-2">
    {cookie.service !== organization && (
      <div className="font-bold underline text-center">
        <Link href={cookie.url}>{cookie.service}</Link>
      </div>
    )}
    {toDomains(cookie).map((domain) => (
      <div key={domain}>{domain}</div>
    ))}
  </div>
);

export default CookieService;
